import { ServerCredentialInfo, ServerDeploymentInfo } from '@/api/type-server.ts'

export class Deployment {
  resID: string
  name: string
  description: string
  gateway: {
    resID: string
    url: string
    port: number
    public: boolean
  }
  runtimeEnv: {
    type: number
    systemEnv: {
      fromImageId: number
      fromSnapshotId: number
      cmd: string
      envs: string
      extraPorts: number[]
    }
    hardwareEnv: {
      resource: {
        cpus: number
        gpus: number
        diskGB: number
        gpuName: string
        domain: string
        agentDomains: number[]
        agentDriver: number
        cpuName: string
        ramMB: number
        gpuRamMB: number
        attributeTags: number
        machineClassTag: string
        machineCategory: number
        unitQty: number
      }
    }
  }
  totalCostCent: number
  ttlSeconds: number
  maxReplicas: number
  credentials: ServerCredentialInfo[]

  constructor(props: ServerDeploymentInfo) {
    this.resID = props.resID
    this.name = props.name
    this.description = props.description
    this.gateway = {
      resID: props.gateway.resID,
      url: props.gateway.url,
      port: props.gateway.port,
      public: props.gateway.public,
    }
    this.runtimeEnv = {
      type: props.runtimeEnv.type,
      systemEnv: {
        fromImageId: props.runtimeEnv.systemEnv.fromImageId,
        fromSnapshotId: props.runtimeEnv.systemEnv.fromSnapshotId,
        cmd: props.runtimeEnv.systemEnv.cmd,
        envs: props.runtimeEnv.systemEnv.envs,
        extraPorts: props.runtimeEnv.systemEnv.extraPorts,
      },
      hardwareEnv: {
        resource: {
          cpus: props.runtimeEnv.hardwareEnv.resource.cpus,
          gpus: props.runtimeEnv.hardwareEnv.resource.gpus,
          diskGB: props.runtimeEnv.hardwareEnv.resource.diskGB,
          gpuName: props.runtimeEnv.hardwareEnv.resource.gpuName,
          domain: props.runtimeEnv.hardwareEnv.resource.domain,
          agentDomains: props.runtimeEnv.hardwareEnv.resource.agentDomains,
          agentDriver: props.runtimeEnv.hardwareEnv.resource.agentDriver,
          cpuName: props.runtimeEnv.hardwareEnv.resource.cpuName,
          ramMB: props.runtimeEnv.hardwareEnv.resource.ramMB,
          gpuRamMB: props.runtimeEnv.hardwareEnv.resource.gpuRamMB,
          attributeTags: props.runtimeEnv.hardwareEnv.resource.attributeTags,
          machineClassTag: props.runtimeEnv.hardwareEnv.resource.machineClassTag,
          machineCategory: props.runtimeEnv.hardwareEnv.resource.machineCategory,
          unitQty: props.runtimeEnv.hardwareEnv.resource.unitQty,
        },
      },
    }
    this.totalCostCent = props.totalCostCent
    this.ttlSeconds = props.ttlSeconds
    this.maxReplicas = props.maxReplicas
    this.credentials = props.credentials || []
  }
}
